import { render, staticRenderFns } from "./ProjectCrud.vue?vue&type=template&id=50fa0c60"
import script from "./ProjectCrud.vue?vue&type=script&lang=js"
export * from "./ProjectCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports